<template>
  <v-container class="pa-0 ma-0 academics-page">
    <!-- <h1 class="d-lg-none show-title mb-10">{{ content.title }}</h1> -->
    <h1 class="show-title mb-10">{{ content.title }}</h1>

    <!-- <div class="academics-text">{{ content.page }}</div> -->
    <div class="academics-text">
      <p>
        You can explore NOVA’s research through the NOVA Research Portal. Find
        out our Research Units, Researcher profiles and the science being
        developed at our University.
      </p>
      <p>
        We invite you to search by researcher name, research unit, concept or
        free-text to discover our community of researchers, get to know our
        research expertise and visualize our collaboration network, here:
      </p>
      <a href="https://novaresearch.unl.pt/">https://novaresearch.unl.pt/</a>
    </div>
  </v-container>
</template>

<script>
export default {
  name: 'PartnershipCollaborations',
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style></style>
